"use client";

import { c as _c } from "react/compiler-runtime";
import { lazy, RefObject, Suspense, useRef, useState } from "react";
import { SkillsetItemRecordFragmentQueryData } from "@/interface/blocks";
import { useIntersection } from "react-use";
const HeadlessTransition = lazy(() => import("@/components/datocms/client/HeadlessTransition"));
export function SkillSetItem(t0) {
  const $ = _c(24);
  const {
    skill,
    bgColor,
    progressColor,
    progressTextColor
  } = t0;
  const ref = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      root: null,
      rootMargin: "0px",
      threshold: 0.1
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const intersectionOptions = t1;
  const [isShowing, setIsShowing] = useState(false);
  const observer = useIntersection(ref as RefObject<HTMLDivElement>, intersectionOptions);
  if (observer && observer.intersectionRatio > intersectionOptions.threshold) {
    if (!isShowing) {
      setIsShowing(true);
    }
  }
  let t2;
  if ($[1] !== skill.name) {
    t2 = <span className="p-0.5 font-semibold">{skill.name}</span>;
    $[1] = skill.name;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== skill.shortDesc) {
    t3 = skill.shortDesc && <span className="p-0.5 text-sm font-normal italic sm:text-base">{skill.shortDesc}</span>;
    $[3] = skill.shortDesc;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `relative h-5 w-full overflow-hidden rounded-2xl ${bgColor || "bg-white"}`;
  const t5 = `${skill.progress}%`;
  let t6;
  if ($[5] !== t5) {
    t6 = {
      width: t5
    };
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = `w-full ${progressColor || "bg-red-500"}`;
  const t8 = `pr-3 text-sm font-medium ${progressTextColor || "text-white"}`;
  let t9;
  if ($[7] !== skill.progress || $[8] !== t8) {
    t9 = <span className={t8}>{skill.progress}%</span>;
    $[7] = skill.progress;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== isShowing || $[11] !== t7 || $[12] !== t9) {
    t10 = <Suspense><HeadlessTransition as="div" appear={true} show={isShowing} enter="transition-transform origin-left duration-250" enterFrom="scale-x-0" enterTo="scale-x-100" className={t7}>{t9}</HeadlessTransition></Suspense>;
    $[10] = isShowing;
    $[11] = t7;
    $[12] = t9;
    $[13] = t10;
  } else {
    t10 = $[13];
  }
  let t11;
  if ($[14] !== t10 || $[15] !== t6) {
    t11 = <div ref={ref} className="absolute top-0 bottom-0 left-0 flex items-center justify-end bg-transparent text-right align-middle" style={t6}>{t10}</div>;
    $[14] = t10;
    $[15] = t6;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t11 || $[18] !== t4) {
    t12 = <div className={t4}>{t11}</div>;
    $[17] = t11;
    $[18] = t4;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  let t13;
  if ($[20] !== t12 || $[21] !== t2 || $[22] !== t3) {
    t13 = <div className="mb-4 flex flex-col text-sm sm:text-base md:text-lg xl:text-xl">{t2}{t3}{t12}</div>;
    $[20] = t12;
    $[21] = t2;
    $[22] = t3;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  return t13;
}
export default function SkillSet(t0) {
  const $ = _c(11);
  const {
    skills,
    bgColor,
    progressColor,
    progressTextColor
  } = t0;
  let t1;
  if ($[0] !== bgColor || $[1] !== progressColor || $[2] !== progressTextColor || $[3] !== skills) {
    let t2;
    if ($[5] !== bgColor || $[6] !== progressColor || $[7] !== progressTextColor) {
      t2 = (skill, index) => {
        const key = `key-${skill.id}-${skill.name}-${index}`;
        return <SkillSetItem key={key} skill={skill} bgColor={bgColor} progressColor={progressColor} progressTextColor={progressTextColor} />;
      };
      $[5] = bgColor;
      $[6] = progressColor;
      $[7] = progressTextColor;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = skills.map(t2);
    $[0] = bgColor;
    $[1] = progressColor;
    $[2] = progressTextColor;
    $[3] = skills;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[9] !== t1) {
    t2 = <>{t1}</>;
    $[9] = t1;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
}